import React from 'react';
import { Link } from 'react-router-dom';
// import StarRatingComponent from 'react-star-rating-component';
import { connect } from 'react-redux';
// import { browserHistory } from 'react-router';
import { bindActionCreators } from 'redux';
import * as documentUploadActions from '../../actions/documentUploadActions';
import * as constant from '../../constants/constant';
import validator from './../common/validator.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as dashboardActions from "../../actions/dashboardActions";
import {
	confirmAlert
} from 'react-confirm-alert';
const btnSize = { fontSize: '13' };
class SpecialistUploadDocuments extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			spinner: false,
			isLoader: true,
			documentTypes: [],
			oldFile: '',
			documentName: { value: '', isValid: true, message: '' },
			documentTypeId: { value: '', isValid: true, message: '' },
			file: { value: '', isValid: true, message: '' },
			fileOriginalName: '',
			logoutButton: false
		}
		this.resetValidationStates = this.resetValidationStates.bind(this);
		this.onChangeDocument = this.onChangeDocument.bind(this);
		this.reSetDocumentForm = this.reSetDocumentForm.bind(this);
		this.uploadDocument = this.uploadDocument.bind(this);
		this.onLogoutclick = this.onLogoutclick.bind(this);
		this.toggle = this.toggle.bind(this)
		this._logout = this._logout.bind(this)
		this.tooltip = this.tooltip.bind(this)
		this.handleClick = this.handleClick.bind(this);
		this.handleOutsideClick = this.handleOutsideClick.bind(this);

	}
	tooltip() {
		confirmAlert({
			customUI: ({ onClose }) => {
				return (
					<div className='custom-ui specialist-ui-custom-padding'>
						<a to="#" style={{ cursor: "pointer" }} className="closeBtn" onClick={onClose}></a>


						<table className="">
							<thead>
							</thead>
							<tbody>
								<tr>
									<td>Degree Certificate</td>
									<td>Proof of qualification issued by the graduating university</td>
								</tr>
								<tr>
									<td>Experience Certificates</td>
									<td>Employment reference letters issued by current & past organisations with employment dates</td>
								</tr>
								<tr>
									<td>Identification Proof</td>
									<td><span>At least one of the below:</span>
										<p>Valid passport</p>
										<p>Driving licence</p>
										<p>Government-Issued ID Card</p>
									</td>
								</tr>
								<tr>
									<td>Limit File Size</td>
									<td>5MB</td>
								</tr>
								<tr>
									<td>Other</td>
									<td>Any other supporting or relevant documents</td>
								</tr>
								<tr>
									<td>Proof of Address</td>
									<td><span>At least one of the below:</span>
										<p>Utility Bill issued in the last 3 months</p>
										<p>Bank Statement issued in the last 3 months</p></td>
								</tr>

								<tr>
									<td>Proof of Certifications</td>
									<td>Proof of specialisation issued by medical regulator or other licensing body</td>
								</tr>

								<tr>
									<td>Type</td>
									<td>Jpeg, PDF</td>
								</tr>

							</tbody>
						</table>




						{/* <h1>Currency Exchange Rate</h1> */}
						{/* <p> {nextProps.convertedCurrency.query.amount} {nextProps.convertedCurrency.query.from} = {currancy} {localStorage.getItem('currency')}</p> */}
						{/* <span>The exchange rate is just for reference and is an estimate.The actual amount charged will be dependent on the payment gateway and the exchange rate used by them at the point of payment</span> */}

					</div>
				)
			}
		})
	}
	_logout(event) {
		let userId = localStorage.getItem('userId')
		this.props.logoutAction.logout({ 'userId': userId })
		event.preventDefault();
		localStorage.clear();
		this.props.history.push('/');
	}
	toggle() {
		var windowWidth = $(window).width();
		if (windowWidth < 768) {
			$("body").toggleClass("sidebar-open");
		} else {
			$("body").toggleClass("sidebar-collapse");
		}
	}
	onLogoutclick(data) {
		if (this.state.logoutButton == false) {
			this.setState({
				logoutButton: true
			});
		}
		else {
			this.setState({
				logoutButton: false
			});
		}
	}

	componentWillMount() {
		let user = JSON.parse(localStorage.getItem('user'));
		this.setState({
			isLoader: false
		})
		let objectDocumentType = {
			userType: user.type,
			userId: user._id
		}
		this.props.actions.getDocumentType(objectDocumentType);
		if (this.props.match.params.documentId) {
			let documentId = this.props.match.params.documentId;
			this.props.actions.getSpecialistDocumentById(documentId);
		} else {
			
			this.setState({
				documentName: { value: '', isValid: true, message: '' },
				documentTypeId: { value: '', isValid: true, message: '' }
			})
		}

	}

	reSetDocumentForm() {
		var state = this.state
		this.setState({
			file: { value: '', isValid: true, message: '' },
			documentName: { value: '', isValid: true, message: '' },
			documentTypeId: { value: '', isValid: true, message: '' }
		})
		document.getElementById('documentName').value = ''
		document.getElementById('documentTypeId').value = ''
		document.getElementById('fileID').value = ''
	}
	uploadDocument(event) {
		event.preventDefault();
		var state = this.state;
		if (!validator.isValid(state.file.value) && this.state.oldFile == '') {
			state.file.isValid = false;
			state.file.message = 'Document is required';
			this.setState({ file: { value: '', isValid: false, message: 'Document is required' } });
		} else {
			state.file.isValid = true;
			state.file.message = '';
			this.setState({ file: { value: state.file.value, isValid: true, message: '' } });
		}
		if (!validator.isValid(state.documentName.value)) {
			state.documentName.isValid = false;
			state.documentName.message = 'Document name is required';
			this.setState({ documentName: { value: '', isValid: false, message: 'Document name is required' } });
		} else {
			state.documentName.isValid = true;
			state.documentName.message = '';
			this.setState({ documentName: { value: state.documentName.value, isValid: true, message: '' } });
		}
		if (!validator.isValid(state.documentTypeId.value)) {
			state.documentTypeId.isValid = false;
			state.documentTypeId.message = 'Document type is required';
			this.setState({ documentTypeId: { value: '', isValid: false, message: 'Document type is required' } });
		} else {
			state.documentTypeId.isValid = true;
			state.documentTypeId.message = '';
			this.setState({ documentTypeId: { value: state.documentTypeId.value, isValid: true, message: '' } });

		}
		if ((this.state.file.value != '' || this.state.oldFile) && this.state.documentName.value != '' && this.state.documentTypeId.value != '' && (this.state.file.message == '' || this.state.file.message == undefined) && (this.state.documentName.message == '' || this.state.documentName.message == undefined) && (this.state.documentTypeId.message == '' || this.state.documentTypeId.message == undefined)) {
			let uploadDocumentObj = {
				userId: localStorage.getItem('userId'),
				documentName: this.state.documentName.value,
				documentTypeId: this.state.documentTypeId.value,
				file: this.state.file.value ? this.state.file.value : this.state.oldFile
			}
			if (this.props.match.params.documentId) {
				uploadDocumentObj.documentId = this.props.match.params.documentId
			}
			this.setState({ spinner: true })
			this.setState({
				file: { value: '', isValid: true, message: '' },
				documentName: { value: '', isValid: true, message: '' },
				documentTypeId: { value: '', isValid: true, message: '' }
			})
			document.getElementById('documentName').value = ''
			document.getElementById('documentTypeId').value = ''
			document.getElementById('fileID').value = ''
			this.props.actions.uploadSpecialistDocument(uploadDocumentObj, this.props);


		}
	}
	onChangeDocument(event) {
		var state = this.state;
		if (event.target.name == 'file') {
			state[event.target.name].value = event.target.files[0];
			state.fileOriginalName = event.target.files[0] ? event.target.files[0].name : ''
		} else {
			state[event.target.name].value = event.target.value;
		}


		this.resetValidationStates();
		if (event.target.name == "file") {
			if (event.target.files && event.target.files.length > 0) {
				if (!validator.fileValidateFormate(event.target.files[0])) {
					state.file.isValid = false;
					state.file.message = 'Please choose following format jpeg, jpg, png,Jpeg,pdf';
					state.fileOriginalName = ''
					this.setState({ file: { value: '', isValid: false, message: 'Please choose following format jpeg, jpg, png, pdf' } });
				} else if (!validator.fileValidateSize(state.file.value)) {
					state.file.isValid = false;
					state.file.message = 'Docs Size too large max size 5 mb';
					state.fileOriginalName = ''
					this.setState({ file: { value: '', isValid: false, message: 'Docs Size too large max size 5 mb' } });
				} else {
					this.setState({ file: { value: event.target.files[0], isValid: true, message: '' } });

					return true
				}
			} else {

				state.file.isValid = false;
				state.file.message = 'Document is required';
				this.setState({ file: { value: '', isValid: false, message: 'Document is required' } });
			}

		} else if (event.target.name == "documentName") {

			if (event.target.value.length > 0) {
				if (!validator.isValid(state.documentName.value)) {
					state.documentName.isValid = false;
					state.documentName.message = 'Not a valid Document name';
					this.setState({ documentName: { value: '', isValid: false, message: 'Not a valid Document name' } });

				} else {
					this.setState({ documentName: { value: state.documentName.value, isValid: true, message: '' } });

					return true
				}
			} else {
				state.documentName.isValid = false;
				state.documentName.message = 'Document name is required';
				this.setState({ documentName: { value: '', isValid: false, message: 'Document name is required' } });

			}
		} else if (event.target.name == "documentTypeId") {

			if (event.target.value && event.target.value.length > 0) {
				if (!validator.isValid(state.documentTypeId.value)) {
					state.documentTypeId.isValid = false;
					state.documentTypeId.message = 'Not a valid Document type';
					this.setState({ documentTypeId: { value: '', isValid: false, message: 'Not a valid Document type' } });

				} else {
					this.setState({ documentTypeId: { value: state.documentTypeId.value, isValid: true, message: '' } });
					return true
				}
			} else {

				state.documentTypeId.isValid = false;
				state.documentTypeId.message = 'Document type is required';
				this.setState({ documentTypeId: { value: '', isValid: false, message: 'Document type is required' } });

			}
		}
	}

	resetValidationStates() {
		var state = this.state;
		Object.keys(state).map(key => {
			if (state[key].hasOwnProperty('isValid')) {
				state[key].isValid = true;
				state[key].message = '';
			}
		});
		this.setState(state);
	}
	componentWillReceiveProps(nextProps) {
		console.log(nextProps)
		this.setState({
			documentTypes: nextProps.documentTypes,
			isLoader: false
		})
		if (nextProps.specialistDocumentData && nextProps.specialistDocumentData.success && this.props.match.params.documentId) {
			this.setState({
				oldFile: nextProps.specialistDocumentData.documentUrl,
				file: { value: nextProps.specialistDocumentData.documentUrl ? '' : this.state.file.value, isValid: true, message: '' },
				documentName: { value: nextProps.specialistDocumentData.documentName ? nextProps.specialistDocumentData.documentName : this.state.documentName.value, isValid: true, message: '' },
				documentTypeId: { value: nextProps.specialistDocumentData.documentTypeId ? nextProps.specialistDocumentData.documentTypeId : this.state.documentTypeId.value, isValid: true, message: '' }
			})
		}
		// else {
		// 	this.setState({
		// 		spinner: false,
		// 		file: { value: '', isValid: true, message: '' },
		// 		documentName: { value: '', isValid: true, message: '' },
		// 		documentTypeId: { value: '', isValid: true, message: '' },
		// 		fileOriginalName: ''
		// 	})
		// 	document.getElementById('documentName').value = ''
		// 	document.getElementById('documentTypeId').value = ''
		// 	document.getElementById('fileID').value = ''
		// }
	}

	handleOutsideClick(e) {
		// ignore clicks on the component itself
		if (this.node && this.node.contains(e.target)) {
			return;
		}

		this.handleClick();
	}
	handleClick() {
		if (!this.state.logoutButton) {
			// attach/remove event handler
			document.addEventListener('click', this.handleOutsideClick, false);
		} else {
			document.removeEventListener('click', this.handleOutsideClick, false);
		}

		this.setState(prevState => ({
			logoutButton: !prevState.logoutButton,
		}));
	}

	render() {
		var documentTypes = this.state.documentTypes ? this.state.documentTypes : [];

		var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
		var defaultImagePath = user.gender == 'Male' ? constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_m.png' : constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_f.png';

		if (user.image == constant.DEFAULT_USER_IMAGE) {
			var imagePath = user.gender == 'Male' ? constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_m.png' : constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_f.png';
		} else {
			var imagePath = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + localStorage.getItem('userId') + '/' + user.image;
		}
		var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
		var condition = (((user.userName != undefined || user.gender != undefined) && user.availabilityCount > 0) && user.isVerified == '2')
		var userType = localStorage.getItem('userType');
		return (
			<div>
				<header className="main-header">
				<Link to={condition ? "/specialist/my-appointment" : null} className="logo">						<span className="logo-mini">{userType === 'specialist' ? <img src={require('../../images/img/logo_er_ms_specialist.png')} alt="" /> : <img src={require('../../images/img/logo_er_ms.png')} alt="" />}</span>
						<span className="logo-lg">{userType === 'specialist' ? <img src={require('../../images/img/logo_er.png')} alt="" /> : <img src={require('../../images/img/logo_er_old.png')} alt="" />}</span> </Link>
					<nav className="navbar navbar-static-top" role="navigation">
						<Link href="#" className="sidebar-toggle" data-toggle="push-menu" role="button" onClick={this.toggle}> <img src={require('../../images/img/menu_list.svg')} alt="" /> <span className="sr-only">Toggle navigation</span> </Link>
						<div className="navbar-custom-menu">
							<ul className="nav navbar-nav">
								<li ref={node => { this.node = node; }} onClick={this.handleClick} className={this.state.logoutButton == true ? "dropdown user user-menu show" : "dropdown user user-menu"}>

									<Link href="#" className="dropdown-toggle" data-toggle="dropdown">
										<img src={imagePath} className="user-image" alt="User Image" onError={(e) => { e.target.src = defaultImagePath }} />
										<span className="hidden-xs name-capitalize">{user.firstName ? user.firstName : ''} {user.lastName ? user.lastName : ''}</span> </Link>
									<ul className={this.state.logoutButton === true ? "dropdown-menu popupdropdown show" : "dropdown-menu popupdropdown"}>

										<li className="user-setting">	<Link to={{ pathname: "/specialist/my-settings", state: 1 }}>

											<img
												src={require('../../images/Slicing/Settings-profile.png')}
												className="user-image"
												alt="User Image"
												onError={e => {
													e.target.src = defaultImagePath;
												}}
											/>
											<span>Settings</span>
										</Link></li>
										<li
											className="user-footer passwordLink"
										// style={{ textAlign: "center" }}
										>

											<Link

												className="uploadLink"
												onClick={this._logout}
											>
												<img
													src={require('../../images/Slicing/logout-profile.png')}
													className="user-image"
													alt="User Image"
													onError={e => {
														e.target.src = defaultImagePath;
													}}
												/>
												<span>	Sign out</span>
											</Link>
										</li>
									</ul>
								</li>
							</ul>
						</div>
					</nav>
				</header>
				<div className="content-wrapper">

					<section className="content container-fluid">
						<ToastContainer  position="bottom-left" rtl={true}/>
						<div className="row">
							<div className="col-md-12">
								<div className="boxMrgB proCalendar">
									<div className="nav-tabs-custom">
										<ul className="nav nav-tabs">
											<li ><Link href="#tab_1" data-toggle="tab" className="active show">Upload Documents</Link></li>
										</ul>
										<form className="login-form" id="documentUploadForm" name="form" onSubmit={this.uploadDocument.bind(this)}>
											<div className="row">

												<div className="col-md-12">
													<div className="tab-content tabother ">
														<div className="row">
															<div className="col-md-12">

																<div className="specailDetails ">
																	<div className="row">
																		<div className="col-md-5 m-o-auto">
																			<div className="boxMrgB choseFile">
																				<div className="input-group inputBg text-center bggrey">
																					<input type="file" className="form-control" id="fileID" style={{ "display": "none" }} name="file" onChange={this.onChangeDocument} />
																					<label htmlFor="fileID" className="fa fa-file cusfaicon"><span className="choosefile">Choose File</span></label>
																				</div>
																				<p style={{ marginTop: 6 }}>{this.state.fileOriginalName ? this.state.fileOriginalName : ''}</p>
																				<span className="help-block" style={{ fontSize: 11 }}>{this.state.file.message}</span>
																			</div>
																		</div>
																	</div>
																	<div className="row">
																		<div className="col-md-5 m-o-auto">
																			<div className="boxMrgB">
																				<div className="input-group inputBg"> <span className="input-group-addon"><i className="fa "><img src={require('../../images/img/file_img.png')} alt="" /></i></span>
																					<input type="" className="form-control" placeholder="Document Name" id="documentName" name="documentName" onChange={this.onChangeDocument} value={this.state.documentName.value} />
																				</div>
																				<span className="help-block" style={{ fontSize: 11 }}>{this.state.documentName.message}</span>
																			</div>

																		</div>

																	</div>
																	<div className="row">
																		<div className="col-md-5 m-o-auto">
																			<div className="boxMrgB">
																				<div className="input-group inputBg"> <span className="input-group-addon"><i className="fa "><img src={require('../../images/img/file_img.png')} alt="" /></i></span>
																					<select className="form-control selectBN" name="documentTypeId" onChange={this.onChangeDocument} id="documentTypeId" value={this.state.documentTypeId.value}>
																						<option value="">Select Document Type</option>
																						{documentTypes.length > 0 ? documentTypes.map((option, index) => <option value={option._id} key={index}>{option.name}</option>) : 'No record'}</select>
																				</div>
																				<span className="help-block" style={{ fontSize: 11 }}>{this.state.documentTypeId.message}</span>
																			</div>
																			<div className="tooltip-custom fadeEffect posabr0 helpsvg" data-title="Lorem Ipsum is simply dummy text" onMouseEnter={this.tooltip} >

																				<span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 27 27"><path id="help" class="cls-1" d="M545.135,352.353a3.142,3.142,0,0,0-2.858.635,3.389,3.389,0,0,0-1.271,2.7,0.794,0.794,0,1,0,1.588,0,1.725,1.725,0,0,1,.635-1.429,1.847,1.847,0,0,1,1.589-.318,1.877,1.877,0,0,1,1.429,1.43,1.736,1.736,0,0,1-.635,1.906,4.733,4.733,0,0,0-1.906,3.811c0,0.477-.431,2.76.794,2.794,0.853,0.025.794-2.317,0.635-2.794a3.5,3.5,0,0,1,1.43-2.541,3.44,3.44,0,0,0,1.27-3.494A3.6,3.6,0,0,0,545.135,352.353Zm-1.27,12.865a0.953,0.953,0,0,0-.159.635,0.581,0.581,0,0,0,.159.476,1.2,1.2,0,0,0,.635.318,1.467,1.467,0,0,0,.794-0.794,0.824,0.824,0,0,0-.318-0.635A0.766,0.766,0,0,0,543.865,365.218ZM544.5,346A13.5,13.5,0,1,0,558,359.5,13.488,13.488,0,0,0,544.5,346Zm0,25.412A11.912,11.912,0,1,1,556.412,359.5,12,12,0,0,1,544.5,371.412Z" transform="translate(-531 -346)"></path></svg></span>

																			</div>
																		</div>
																	</div>
																	<div className="row">
																		<div className="col-md-12 text-center">
																			<div className="toppad">
																				<button type="button" className="btn btn-warning btn-lg pd-btn" type="submit">Upload{this.state.spinner ? <i className="fa fa-spinner fa-spin" /> : ""}</button>  <button type="button" onClick={this.reSetDocumentForm} className="btn btn-cancel btn-default btn-lg p-d-rst">Reset</button><br/>
																				<div className="Disclaimer"
																				>
																					<p><b>Disclaimer</b></p>
																					<p>By submitting your documents for verification, you affirm that these documents are authentic and represent you and only you.  All documents must be genuine and issued by a bonafide organisation or agency in the jurisdiction they were issued.</p>
																					<p>Additionally, any and all documents you upload will be shared with our verification partners, who will conduct background checks to ensure you are suitably registered and qualified.  These verification partners may transfer these documents outside of your country of residence or citizenship for these purposes.  By clicking ‘Submit’ you confirm that you accept the provisions of this Vetting Disclaimer and agree to be bound by them at all times whilst you are a specialist registered with Medfix Healthcare.</p>

																				</div>
																			</div>
																		</div>
																	</div>
																	
																</div>
																</div>
															</div>
														</div>
													</div>
												</div>
										</form>
									</div>
								</div>
							</div>
						</div>
					</section>

					<div className="Copyrightafterlogin">
						<p>Medfix &copy; 2018. All rights reserved</p>

					</div>
				</div>
			</div>
		);
	}
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {
		documentTypes: state.uploadDocument.userTypeData,
		uploadedSpecialistData: state.uploadDocument.uploadedSpecialistData,
		specialistDocumentData: state.uploadDocument.specialistDocumentData
	};
}
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(documentUploadActions, dispatch),
		logoutAction: bindActionCreators(dashboardActions, dispatch)

	};
}
export default connect(mapStateToProps, mapDispatchToProps)(SpecialistUploadDocuments);
